import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
//<span class="expand-button" (click)="toggle()">{{IsExpanded ? (item.Children ? '-' : '&nbsp;'):(item.Children ? '+' : '&nbsp;')}}</span>
@Component({
    selector: 'node',
    styleUrls: ['./tree.css'],
    template: `
<li>
	<a style="cursor:pointer" [class.selected]="item.selected">  
        <span  *ngIf="ExpandLevel>=0&&IsExpanded&&item.Children" class="expand-button" (click)="toggle()"><i class="fa fa-folder-open"></i></span>
        <span  *ngIf="ExpandLevel>=0&&IsExpanded&&!item.Children" class="expand-button" (click)="toggle()"><i class="fa fa-file-o"></i></span>
        <span  *ngIf="(!IsExpanded||ExpandLevel<0)&&item.Children" class="expand-button" (click)="toggle()"><i class="fa fa-folder"></i></span>
        <span  *ngIf="(!IsExpanded||ExpandLevel<0)&&!item.Children" class="expand-button" (click)="toggle()"><i class="fa fa-file-o"></i></span>
        <input *ngIf="IsMultiSelected" type='checkbox' [(ngModel)]="item.selected" (change)="onSelectMulti(item)" />
        <span (click)="onSelectSingleNode(item)" [class.selected]="item.selected" [class.haschild]="item.Children" >{{item.name}}</span>
    </a>
	<div *ngIf="IsExpanded && ExpandLevel >= 0 && item.Children" class="subtree">
        <tree [data]="item.Children" [subtree]="true"
            [ExpandLevel]="ExpandLevel"
            [IsExpanded] = "IsExpanded"
            [IsMultiSelected] = "IsMultiSelected" 
            [selectedNode]="selectedNode"
            (selectedNodeChange)="OnSelectedNodeChange($event)"
            [selectedNodes]="selectedNodes"           
            (selectedNodesChange)="OnSelectedNodesChange($event)"
            (selectedDropTreeChange)="OnselectedDropTreeChange($event)">
        </tree>
    </div>
</li>
`
})
export class Node implements OnInit {
    @Input() ExpandLevel:number;
    @Input() IsMultiSelected: boolean;
    @Input() IsExpanded: boolean;
    @Input() item: any;
    
    @Input() selectedNode: any;
    @Output() selectedNodeChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() selectedNodes: any[];
    @Output() selectedNodesChange: EventEmitter<any[]> = new EventEmitter<any[]>();
    @Output() selectedDropTreeChange: EventEmitter<any[]> = new EventEmitter<any[]>();
    
    openTree:any;
    ngOnInit() {
        if (!this.item.selected)
            this.item.selected = false;
        if (this.IsExpanded == undefined)
            this.IsExpanded = false;
    }

    toggle() {
        if(this.ExpandLevel < 0)
        {
            this.ExpandLevel = 0;
            this.IsExpanded = false;
        }
        this.IsExpanded = !this.IsExpanded;
        this.openTree = true;
        this.selectedDropTreeChange.emit(this.openTree);
    }
    OnselectedDropTreeChange($event) {
        this.selectedDropTreeChange.emit($event);
    }
    OnSelectedNodeChange($event) {
        this.selectedNodeChange.emit($event);
    }

    OnSelectedNodesChange($event) {
        this.selectedNodesChange.emit($event);
    }

    onSelectSingleNode(node) {
        this.item.selected = true;
        this.item.OpenTree = false;
        this.selectedNode = node;

        this.selectedNodeChange.emit(this.selectedNode);
    }

    onSelectMulti(node) {        
        if (this.item.selected) {
            this.item.OpenTree = false;
            this.selectedNodes.push(node);
        }
        else {
            for (let i = 0; i < this.selectedNodes.length; i++) {
                if (this.selectedNodes[i].id == node.id) {
                    this.selectedNodes.splice(i, 1);
                    break;
                }
            }
        }
        this.selectedNodesChange.emit(this.selectedNodes);
    }
}

@Component({
    selector: 'tree',
    styleUrls: ['./tree.css'],
    template: `
<ul class='tree' *ngFor="let it of data">
    <node [item]="it"
        [ExpandLevel]="ExpandLevel-1"
        [IsExpanded] = "IsExpanded"
        [IsMultiSelected] = "IsMultiSelected" 
        [selectedNodes] = "selectedNodes"
        (selectedNodesChange)="selectMultiNode($event)"
        [selectedNode]="selectedNode"
        (selectedNodeChange)="selectSingleNode($event)"
        (selectedDropTreeChange)="OnselectedDropTreeChange($event)">
    </node>
</ul>
`,

})
export class Tree implements OnInit {
    @Input() ExpandLevel:number;
    @Input() IsMultiSelected: boolean;
    @Input() data: any[];
    @Input() subtree: boolean;
    @Input() IsExpanded: boolean;

    @Input() selectedNode: any;
    @Output() selectedNodeChange: EventEmitter<any> = new EventEmitter<any>();

    @Input() selectedNodes: any[];
    @Output() selectedNodesChange: EventEmitter<any[]> = new EventEmitter<any[]>();
    @Output() selectedDropTreeChange: EventEmitter<any[]> = new EventEmitter<any[]>();
    openTree:any;
    ngOnInit() {
        if (this.ExpandLevel == undefined) this.ExpandLevel = 10;
        if (this.IsExpanded == undefined)
            this.IsExpanded = true;
        if (this.subtree == undefined)
            this.subtree = false;
        if (this.selectedNodes == undefined)
            this.selectedNodes = [];

    }
    OnselectedDropTreeChange($event) {
        this.openTree = true;
        this.selectedDropTreeChange.emit(this.openTree);
    }
    selectMultiNode(eventData: any[]) {
        this.selectedNodes = eventData;
        this.selectedNodesChange.emit(this.selectedNodes);
    }

    selectSingleNode(nodeData: any) {
        this.unSelectTree(this.data, nodeData.id);
        this.selectedNode = nodeData;
        this.selectedNodeChange.emit(this.selectedNode);
    }

    unSelectTree(data: any[], id_exclude: any) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id != id_exclude) {
                data[i].selected = false;
            }
            if (data[i].Children) {
                this.unSelectTree(data[i].Children, id_exclude);
            }
        }
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/directives/tree.ts